/**
* Google Map View Script
* ------------------------------------------------------------------------------
*
* @namespace - GoogleMap
*/

var attr = {
    dataLat: "data-lat",
    dataLng: "data-lng",
}

var selectors = {
    map: '[data-map]',
};

/**
* GoogleMapVeiw Constructor
*
* @param {string} el - selector for the section container DOM element
* @param {object} options - view options: {}
*/
function GoogleMap(el, options) {
    el = el || "body";
    this.el = el;
    this.options = options || {};
    this.init(this.el, this.options);
};

GoogleMap.prototype = $.extend({}, GoogleMap.prototype, {
    init: function (el, options) {
        var defaults = {
            zoom: 11,
        }
        var settings = $.extend({}, defaults, options);
        this.settings = settings;
    },

    render: function () {
        var $el = $(this.el);

        if (!$el.length) {

            return this;
        }

        var $ui = this.renderUI($el);

        if (!$ui.map.length) {
            return this;
        }

        var dataLat = $el.attr(attr.dataLat);
        var dataLng = $el.attr(attr.dataLng);

        if (!dataLat || !dataLng) {
        }

        var latLng = new google.maps.LatLng(parseFloat(dataLat), parseFloat(dataLng));
        var mapOptions = $.extend({}, { center: latLng }, this.settings);
        var map = this.renderMap($el, $ui, mapOptions);
        var defaultMarker = this.renderDefaultMarker(map, mapOptions);

        // Update NS
        this.$el = $el;
        this.$ui = $ui;
        this.mapOptions = mapOptions;
        this.map = map;
        this.defaultMarker = defaultMarker;

        return this;
    },

    renderUI: function ($el) {
        return {
            map: $(selectors.map, $el),
        }
    },

    renderMap: function ($el, $ui, mapOptions) {
        var mapEl = $ui.map.get(0);
        var map = new google.maps.Map(mapEl, mapOptions);
        return map;
    },

    renderDefaultMarker: function (map, mapOptions) {
        return new google.maps.Marker({
            position: mapOptions.center,
            map: map,
        });
    },
});

module.exports = GoogleMap;



//////////////////
// WEBPACK FOOTER
// ./map_and_directions/js/googleMap.js
// module id = 147
// module chunks = 3